export const formatUserName = (email: string): string => {
    if (!email || !email.includes('@')) return email;

    return email
        .split('@')[0]
        .replaceAll('.', ' ')
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
  };